import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { T, Button } from 'components'
import { unsubscribeEmails } from 'store/actions'

const Unsubscribe = () => {
  const dispatch = useDispatch()
  // const { hash, messageId } = match.params
  const { hash, messageId = '' } = useSelector(s => s.router.location.query)

  return (
    <div>
      <T as="h2" label="support/going|basicHTML" macros={{ subscription: 'emails' }} />
      <Button
        onClick={() => dispatch(unsubscribeEmails({ hash, messageId }))}
        fill="none"
        label="support/unsubscribe"
      />
      <T as="p" label="support/miss|basicHTML" />
      <T as="h2" label="support/manage|basicHTML" />
      <Button to="/myprofile/settings" size="large" label="support/buttonMng" />
    </div>
  )
}

export default Unsubscribe
